import { goToHome } from '@ykz/ykz-util/platform';
export default {
  name: 'carefullyEmpty',
  props: {},
  data: function data() {
    return {
      dialog: {
        show: false,
        showContent: false
      }
    };
  },
  methods: {
    showDialog: function showDialog() {
      var that = this;
      this.dialog.show = true;
      this.dialog.hasShow = true;
      setTimeout(function () {
        that.dialog.showContent = true;
      }, 100);
    },
    closeDialog: function closeDialog() {
      var that = this;
      that.dialog.showContent = false;
      setTimeout(function () {
        that.dialog.show = false;
      }, 200);
    },
    goShopping: function goShopping() {
      // window.location.href =
      //   '/front/promoter/shoppingMallv2?weChatId=1&fromWeChatId=1'
      var url = '/front/promoter/shoppingMallv2?weChatId=1&fromWeChatId=1';
      goToHome(url);
    }
  }
};